<template>
  <SettlementStepper
    :vehicle-image="vehicleImage"
    :settlement="settlement"
    :stepper-value="true"
    :vehicle-title="vehicleTitle"
    :vehicle-sub-title="vehicleSubTitle"
    :settlement-steps="settlementSteps"
    :show-stepper-history="false"
    :is-mobile="$q.screen.xs"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SettlementWidget',
  computed: {
    ...mapState({
      settlement: (state) => state.settlement.settlement
    }),
    ...mapGetters('settlement', ['settlementSteps']),
    ...mapGetters('quote', ['vehicleTitle', 'vehicleSubTitle', 'vehicleImage'])
  },
  components: {
    SettlementStepper: () => import('../../components/page/settlement-stepper')
  }
};
</script>
